import React from "react";
import { Col, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import clsx from "clsx";

function GeneralPaymentDisclaimerRemark({}) {
  return (
    <div className="mt-4 note-disclaimer-container">
      <div className="p-3 p-lg-4 pt-3 tnc-content disable-scroll">
        <div
          className={clsx("custom-table-info-container mt-2")}
          style={{ background: "unset" }}
        >
          <Row>
            <Col sm={12} lg={6}>
              <div className="mt-3 text-bold-600">FPX Online Transfer</div>
              <Table
                className="withdrawal-table mt-2"
                style={{ width: "100%" }}
              >
                <tbody>
                  <tr>
                    <th style={{ textAlign: "center" }} colSpan={2}>
                      Transfer
                    </th>
                    <th style={{ textAlign: "center" }} width="40%">
                      Process and Update in Account
                    </th>
                  </tr>
                  <tr>
                    <td>Day</td>
                    <td>Time</td>
                    <td width="40%"></td>
                  </tr>
                  <tr>
                    <td rowSpan={2}>
                      Business Day
                      <br />
                      Monday to Friday
                    </td>
                    <td>Before 5pm</td>
                    <td width="40%">By 5.30pm</td>
                  </tr>
                  <tr>
                    <td>After 5pm</td>
                    <td width="40%">By 5.30pm, Next Business Day</td>
                  </tr>
                  <tr>
                    <td>
                      Non-Business Day <br />
                      Saturday,Sunday & Federal Territory Public Holiday
                    </td>
                    <td>Anytime</td>
                    <td width="40%">By 5.30pm, Next Business Day</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col sm={12} lg={6}>
              <div className="mt-3 text-bold-600">Manual Transfer</div>
              <Table
                className="withdrawal-table mt-2"
                style={{ width: "100%" }}
              >
                <tbody>
                  <tr>
                    <th style={{ textAlign: "center" }} colSpan={2}>
                      Request Submit On
                    </th>
                    <th style={{ textAlign: "center" }} width="40%">
                      Process and Update in Account
                    </th>
                  </tr>
                  <tr>
                    <td>Day</td>
                    <td>Time</td>
                    <td width="40%"></td>
                  </tr>
                  <tr>
                    <td rowSpan={2}>
                      Business Day <br />
                      Monday to Friday
                    </td>
                    <td>Before 4pm</td>
                    <td width="40%">By 5.30pm</td>
                  </tr>
                  <tr>
                    <td>After 4pm</td>
                    <td width="40%">By 5.30pm, Next Business Day</td>
                  </tr>
                  <tr>
                    <td>
                      Non-Business Day <br /> Saturday,Sunday & Federal
                      Territory Public Holiday
                    </td>
                    <td>Anytime</td>
                    <td width="40%">By 5.30pm, Next Business Day</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <div className="tnc-bottom-remark mt-3">
            <p>
              * Clients are discouraged from making cash deposit via Cash
              Deposit Machine (CDM).
            </p>
            <p>
              * Bank in slip with client signature is required for cash payment
              via CDM or Over the Counter (OTC).
            </p>
            <p>
              * Cumulative cash deposits exceeding{" "}
              <span className="text-bold-600">RM25k</span> for past 1 year
              requires our management approval and may take longer time to
              process.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GeneralPaymentDisclaimerRemark;
